import React, {useState, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {getPromoterService} from "../../../../services/getPromoterService";
import {getOrder, postCustomer} from "../../../../services/orderService";
import Loader from "../../../../components/Loader/Loader";
import Header from "../Header/Header";
import Footer from "../../../../components/Footer";
import OrderDetails from "../order/OrderDetails";
import Breadcrumbs from "../../../../components/Checkout/Breadcrumbs/BreadCrumbs";
import BillingForm from "../../../../components/Checkout/Billing/BillingForm";
import {Helmet, HelmetProvider} from "react-helmet-async";
import useDataTravel from '../../../../hooks/useDataTravel';
import MetaTags from "../../../../components/MetaTags";

const Billing = () => {
    const currentStep = 1;

    const [promoter, setPromoter] = useState(null);
    const [loading, setLoading] = useState(true);
    const [order, setOrder] = useState(null);
    // This should be deleted!
    const [billed, setBilled] = useState({
        fullName: "",
        email: "",
        address: "",
        zipCode: "",
        country: "",
        idType: "",
        idNumber: "",
        errors: {},
    });
    const navigate = useNavigate();
    const [isFormValid, setIsFormValid] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const [isReservation, setIsReservation] = useState(false);
    const [haveTime, setHaveTime] = useState(false);
    const [localTravelData, setLocalTravelData] = useState(null);

    const { fetchData } = useDataTravel();

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };

    useEffect(() => {
        const fetchPromoter = async () => {
            try {
                const data = await getPromoterService();
                setPromoter(data);
                const order = await getOrder();
                setOrder(order);
                setHaveTime(order.booking.quotation.has_available_time_spots)
                setIsReservation(order.booking.quotation.is_reservation);


                const _travelData = await fetchData(order.booking.quotation.public_id);
                setLocalTravelData(_travelData);


                if (order.customer) {
                    setBilled({
                        publicId: order.customer.public_id,
                        fullName: order.customer.full_name,
                        email: order.customer.email,
                        address: order.customer.address,
                        zipCode: order.customer.zipcode,
                        country: order.customer.country,
                        idType: order.customer.id_type,
                        idNumber: order.customer.id_number,
                        errors: {},
                    })
                }

                if (!order.passengers[0]) {
                    window.alert("No passengers found!");
                    return navigate("/");
                }
                setLoading(false);
            } catch (e) {
                console.log(e);
                //window.alert("Order not found!");
                //localStorage.removeItem("tp_order_id")
                navigate("/");
            }
        };
        fetchPromoter();
    }, [navigate,fetchData]);


    useEffect(() => {
        setIsSmallScreen(window.innerWidth <= 768);

        const handleResize = () => {
            setIsSmallScreen(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [isSmallScreen]);

    const handleBilledChange = (field, value) => {
        let newBilled = {...billed};
        newBilled = {...newBilled, [field]: value};
        setBilled(newBilled);
    };

    const handleBilledBlur = (field, validateFn) => {
        let newBilled = {...billed};
        const error = validateFn(newBilled[field]);
        newBilled = {
            ...newBilled,
            errors: {...newBilled.errors, [field]: error},
        };
        setBilled(newBilled);
    };

    useEffect(() => {
        const formValid =
            billed.fullName &&
            billed.email &&
            billed.address &&
            billed.zipCode &&
            billed.country &&
            billed.idType &&
            billed.idNumber &&
            !billed.errors.fullName &&
            !billed.errors.email &&
            !billed.errors.address &&
            !billed.errors.zipCode &&
            !billed.errors.country &&
            !billed.errors.idType &&
            !billed.errors.idNumber &&
            isChecked;
        setIsFormValid(formValid);
    }, [billed, isChecked]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const customer = {
            full_name: billed.fullName,
            email: billed.email,
            address: billed.address,
            zipcode: billed.zipCode,
            country: billed.country,
            id_type: billed.idType,
            id_number: billed.idNumber,
        }
        if (billed.publicId) {
            customer.public_id = billed.publicId
        }
        const {savedCustomer, payment} = await postCustomer(customer, order.booking.public_id);
        navigate("/checkout/payments");
    }

    if (loading) return <Loader/>;

    const currentUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search

    return (
        <HelmetProvider>
            <MetaTags
                name={promoter.fullname}
                description={order?.booking?.quotation?.itinerary?.description}
                icon={promoter.logoURL}
                title={order?.booking?.quotation?.title}
                url={currentUrl}
                font={localTravelData.data.font ? localTravelData.data.font : null}
                primaryColor={localTravelData.data.colors.primary_color ? localTravelData.data.colors.primary_color : null}
                secondaryColor={localTravelData.data.colors.secondary_color ? localTravelData.data.colors.secondary_color : null}
            />
            <Header promoter={promoter}></Header>
            <div className="billing__container">
                <Breadcrumbs currentStep={currentStep}></Breadcrumbs>
                <div className="main-content">
                    <div className="billing-details__container">
                        <BillingForm
                            data={billed}
                            onChange={handleBilledChange}
                            onBlur={handleBilledBlur}
                        />
                    </div>
                    <OrderDetails numPassengers={order.passengers.length}
                                  quotation={order.booking.quotation}
                                  passengers={order.passengers}
                                  handleSubmitNextStep={handleSubmit}
                                  nextStepLabel={"Ir al pago"}
                                  isFormValid={isFormValid}
                                  handleCheckboxChange={handleCheckboxChange}
                                  showTerms={true}
                                  isReservation={isReservation}
                                  selectDate={order.booking.selected_date ? order.booking.selected_date : ''}
                                  haveTime={haveTime}
                                  selectedOption={order.booking.selected_option ? order.booking.selected_option : ''}
                    />
                </div>
                {!isSmallScreen && (
                <div className="checkout-actions checkout-actions--desktop">
                    <div className="checkbox">
                        <input type="checkbox" onChange={handleCheckboxChange}></input>
                        <label>
                            {/* eslint-disable-next-line */}
                            Acepto <a href="https://trippromoter.com/terminos-y-condiciones/" rel="noreferrer"
                                      target="_blank">los términos y condiciones</a>
                        </label>
                    </div>
                    <button
                        type="button"
                        onClick={handleSubmit}
                        disabled={!isFormValid}
                    >
                        Ir al pago
                    </button>
                </div>
                )}
            </div>
            <Footer promoter={promoter}></Footer>
        </HelmetProvider>
    );
};

export default Billing;
